class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header");
    this.headerIsAlwaysSticky =
      this.getAttribute("data-sticky-type") === "always" ||
      this.getAttribute("data-sticky-type") === "reduce-logo-size";
    this.headerBounds = {};
    this.initializeHeaderPosition();
    this.logo = document.querySelector(".header__heading-logo");
    this.headerContent = document.querySelector(".header");
    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  initializeHeaderPosition() {
    const announcementHeight = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--announcement-height");
    if (announcementHeight) {
      this.header.style.top = announcementHeight;
    } else {
      console.error("Announcement height not set or invalid.");
    }
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }

  updateHeaderHeight() {
    if (this.headerContent) {
      const headerHeight = this.headerContent.offsetHeight + "px";
      document.documentElement.style.setProperty(
        "--header-height",
        headerHeight
      );
    }
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    document.body.classList.add("header-sticky");
    
    const scrollTop = document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      /* Scroll down */
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      /* Scroll up */
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.getAttribute("data-sticky-type") === "reduce-logo-size") {
      this.logo.classList.add("header__logo--small");
      this.headerContent.classList.add("header__padding--small");
      this.updateHeaderHeight();
    }
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
    document.body.classList.add("header-hidden", "header-sticky");
    this.closeMenuDisclosure();
    this.closeSearchModal();
    this.header.style.top = "";
  }

  reveal() {
    if (this.getAttribute("data-sticky-type") === "reduce-logo-size") {
      this.logo.classList.add("header__logo--small");
      this.headerContent.classList.add("header__padding--small");
      this.updateHeaderHeight();
    }
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
    document.body.classList.remove("header-hidden");
    const announcementHeight = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--announcement-height");
    this.header.style.top = announcementHeight;
  }

  reset() {
    if (this.getAttribute("data-sticky-type") === "reduce-logo-size") {
      this.logo.classList.remove("header__logo--small");
      this.headerContent.classList.remove("header__padding--small");
    }
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
    document.body.classList.remove("header-hidden", "header-sticky");
    const announcementHeight = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--announcement-height");
    this.header.style.top = announcementHeight;
    this.updateHeaderHeight();
    setTimeout(() => { this.updateHeaderHeight(); }, 250)
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("header-menu");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define("sticky-header", StickyHeader);

/*
  LSF — tiroir mobile : sous-menus de la rubrique deployee (ex. Vetements > Homme / Femme).

  Bug corrige : MenuDrawer (global.js) attache un handler sur CHAQUE <summary> du tiroir.
  Au clic il fait `detailsElement.closest('.has-submenu').classList.add('submenu-open')`,
  ce qui remonte jusqu'au <ul class="menu-drawer__menu has-submenu"> racine. Or
  component-menu-drawer.css applique `.js .menu-drawer__navigation .submenu-open { visibility: hidden }`
  => tout le menu disparaissait au lieu d'ouvrir le sous-menu.

  On intercepte le clic en phase de capture et on stoppe la propagation : le handler de
  MenuDrawer (attache sur la cible) n'est jamais appele, et le <details> natif s'ouvre/ferme
  normalement.
*/
document.addEventListener(
  "click",
  function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== "function") return;
    if (!target.closest(".lsf-dopen__sub > summary")) return;
    event.stopPropagation();
  },
  true
);

/*
  LSF — tiroir mobile : caler le bas du tiroir sur le bas reel de l'ecran.

  Dawn calcule `height: calc(var(--viewport-height) - var(--header-bottom-position))`.
  --header-bottom-position vaut le bas de `.section-header` (qui englobe aussi la barre
  d'annonce et la barre de recherche mobile), alors que le tiroir demarre plus haut, au bas
  de `.header`. Le tiroir etait donc trop court ou trop long de quelques dizaines de pixels :
  le bouton compte, ancre en bas du tiroir, ne tombait pas au bas de l'ecran et la page
  apparaissait en dessous. Aucune formule CSS ne donne ce decalage de facon fiable, on mesure.
*/
function lsfFitMenuDrawer() {
  const drawer = document.getElementById("menu-drawer");
  if (!drawer) return;

  if (window.innerWidth > 989) {
    drawer.style.height = "";
    return;
  }

  const top = drawer.getBoundingClientRect().top;
  drawer.style.height = Math.max(0, Math.round(window.innerHeight - top)) + "px";
}

lsfFitMenuDrawer();
document.addEventListener("DOMContentLoaded", lsfFitMenuDrawer);
window.addEventListener("load", lsfFitMenuDrawer);
window.addEventListener("resize", lsfFitMenuDrawer);
window.addEventListener("orientationchange", lsfFitMenuDrawer);

/* Recaler juste avant l'ouverture : le header a pu bouger (sticky, barre d'annonce). */
document.addEventListener(
  "click",
  function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== "function") return;
    if (!target.closest("#Details-menu-drawer-container > summary")) return;
    requestAnimationFrame(lsfFitMenuDrawer);
  },
  true
);
